/**
 * Counts down to midnight in the store's timezone, then restarts.
 *
 * The clock is honest about what it measures: time left in the day. Whether
 * that means anything is up to the merchant actually changing the offer.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-nova-countdown]').forEach(start);
  });

  function start(root) {
    var clock = root.querySelector('[data-nova-clock]');
    var hh = root.querySelector('[data-nova-hh]');
    var mm = root.querySelector('[data-nova-mm]');
    var ss = root.querySelector('[data-nova-ss]');
    if (!clock && !hh) return;

    var offsetHours = Number(root.dataset.timezoneOffset || 0);

    tick();
    window.setInterval(tick, 1000);

    function tick() {
      var now = new Date();
      // Shift real time into the store's timezone, then find the end of the
      // current cycle. A 12-hour cycle rolls over at midnight and midday; a
      // 24-hour one rolls over at midnight only.
      var storeNow = new Date(now.getTime() + (offsetHours * 60 + now.getTimezoneOffset()) * 60000);
      var cycle = Number(root.dataset.cycleHours) || 24;
      var next = new Date(storeNow);
      next.setHours(0, 0, 0, 0);
      var elapsed = storeNow - next;
      var period = cycle * 3600000;
      next = new Date(next.getTime() + (Math.floor(elapsed / period) + 1) * period);

      var left = Math.max(0, next - storeNow);
      var h = Math.floor(left / 3600000);
      var m = Math.floor((left % 3600000) / 60000);
      var s = Math.floor((left % 60000) / 1000);

      if (clock) {
        clock.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
        clock.setAttribute('datetime', 'PT' + h + 'H' + m + 'M' + s + 'S');
      }
      if (hh) hh.textContent = pad(h);
      if (mm) mm.textContent = pad(m);
      if (ss) ss.textContent = pad(s);
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }
  }
})();
